import React, { useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { all_routes } from "../../../router/all_routes";
import { convertToUTCString } from "../../../../utils/helpers/helper";
import { formatLeadsData } from "../../../../utils/helpers/formatModulesData";
import { setFilterModel } from "../../../../core/data/redux/filterSlice";
import { customMuiDateFilter } from "../../../../utils/helpers/customMuiDateFilter";

const LeadList = ({ leadsData }) => {
  const route = all_routes;
  const filterModel = useSelector((state) => state.filter.filterModel);
  const dispatch = useDispatch();

  const processedRows = formatLeadsData(leadsData);

  // Columns definition for the DataGrid
  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 160,
      sortable: true,
      renderCell: (params) => (
        <span className=" text-capitalize">
          {params.row.firstName} {params.row.lastName}
        </span>
      ),
    },

    {
      field: "assignedTo",
      headerName: "Caller",
      width: 130,
      renderCell: (params) => (
        <div className="text-capitalize">{params.row.assignedTo}</div>
      ),
    },
    { field: "mobile", headerName: "Phone", width: 100, sortable: true },
    { field: "email", headerName: "Email", width: 210, sortable: true },
    {
      field: "probability",
      headerName: "Probability",
      width: 90,
      renderCell: (params) => (
        <div className="text-capitalize">
          {params?.row?.probability ? params?.row?.probability : "medium"}
        </div>
      ),
      sortable: true,
    },
    {
      field: "currentStatus",
      headerName: "Status",
      width: 110,
      sortable: true,
      renderCell: (params) => {
        return (
          <span
            className={`badge badge-pill badge-status text-capitalize`}
            style={{ backgroundColor: `${params?.row?.currentStatusColor}` }}
          >
            {params.value}
          </span>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 210,
      valueFormatter: (params) =>
        params?.value ? convertToUTCString(params?.value) : "",
      filterOperators: customMuiDateFilter,
      renderCell: (params) => (
        <div>
          {params?.row?.createdTime
            ? convertToUTCString(params?.row?.createdTime)
            : convertToUTCString(params?.row?.lastActivityDate)}
        </div>
      ),
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      width: 210,
      valueFormatter: (params) =>
        params.value ? convertToUTCString(params.value) : "",
      filterOperators: customMuiDateFilter,
      renderCell: (params) => (
        <div>
          {params?.row?.lastActivityDate
            ? convertToUTCString(params?.row?.lastActivityDate)
            : convertToUTCString(params?.row?.createdTime)}
        </div>
      ),
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      {/* DataGrid Table */}
      <DataGrid
        rows={processedRows}
        columns={columns.map((column) => ({
          ...column,
          headerClassName: "bg-light-200",
        }))}
        autoHeight
        hideFooter
        disableExtendRowFullWidth
        onStateChange={(state) => {
          const filteredRowIds = Object.entries(state.filter.filteredRowsLookup)
            .filter(([_, isVisible]) => isVisible === true)
            .map(([rowId]) => rowId); // Keep IDs as strings

          // Filter leadsData based on these IDs
          const filteredData = leadsData?.filter((row) =>
            filteredRowIds.includes(row?._id)
          );
          // Pass the filtered data to the parent
          // setFilteredData(filteredData);
        }}
        sx={{
          "& .sticky-column": {
            position: "sticky",
            right: 0,
            background: "white", // Prevents content from hiding under it
            zIndex: 100, // Keeps it on top
          },
          "& .MuiDataGrid-columnHeaders": {
            background: "white",
            position: "sticky",
            top: 0,
            zIndex: 110,
          },
          "& .MuiDataGrid-virtualScroller": {
            overflowX: "auto",
          },
        }}
        filterModel={filterModel}
        onFilterModelChange={(newModel) => dispatch(setFilterModel(newModel))}
        slots={{
          toolbar: GridToolbar, // Enable filter toolbar above the grid
        }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true }, // Hide Print Button
            csvOptions: { disableToolbarButton: true }, // Hide CSV Export
          },
        }}
      />
    </div>
  );
};

export default LeadList;
